window.addEventListener('DOMContentLoaded', function(e) {
    if (document.querySelector('body.page-template-look-book')) {
        let flag = false;

        if (window.innerWidth <= 992) {
            flag = true;
            let handle = setInterval(() => {
                let single_page_mode = document.querySelector('.df-ui-pagemode');
                if (single_page_mode) {
                    single_page_mode.click();
                    document.querySelector('.df-ui-more').click();
                    clearInterval(handle);
                }
            }, 500);
        }

        window.addEventListener('resize', (e) => {
            let single_page_mode = document.querySelector('.df-ui-pagemode');
            if (window.innerWidth <= 992 && !flag) {
                if (single_page_mode) {
                    single_page_mode.click();
                    document.querySelector('.df-ui-more').click();
                }
                flag = true;
            }
            else if (window.innerWidth > 992 && flag) {
                if (single_page_mode) {
                    single_page_mode.click();
                    document.querySelector('.df-ui-more').click();
                }
                flag = false;
            }
        })
    }
})